/**
 * @file 设置弹窗已读
 * @author liudaoyu
 * {@link https://docs.google.com/document/d/1igztR_t52T1XNtWUNpS45AxFTV6peg6uOP8vx0dgJFU/edit#heading=h.wwj9fsoza4ar}
 */

import Api from '../../../path'
import { fetchData } from '@umu/umu-fetch';

import { AchivementDialogType } from '@umu/umu-types';

export interface IReadDialogInput {
    obj_type: AchivementDialogType; // 必须，弹窗类型
    obj_id?: string; // 可选，弹窗标识 daily_login: 不传; user_level：不传; user_medal：obj_id传medal_id
}

export interface IReadDialogOutput {
    result: boolean;
}

export const readDialog = (data: IReadDialogInput): Promise<IReadDialogOutput> => {
    return fetchData(Api.ACHIEVEMENT_READ_DIALOG, data).then((res: IResponse<IReadDialogOutput>) => {
        return res.data as IReadDialogOutput;
    });
};
